import { useCreateCategory } from "../../../hooks/useCategories";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";

// Redux

import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond

// Import FilePond styles
import "filepond/dist/filepond.min.css";

const EcommerceAddCategories = (props) => {
  document.title = "Creation de catégories d'articles";

  const history = useHistory();
  const createCategoryMutation = useCreateCategory();

  const handleSubmit = async (values) => {
    const newCategory = {
      designation: values.designation,
    };
    createCategoryMutation.mutate(newCategory, {
      onSuccess: () => {
        toast.success(props.t("Catégorie bien ajoutée"), { autoClose: 3000 });
        validation.resetForm();
        history.push("/categories");
        setTimeout(() => window.location.reload(true), 2000);
      },
      onError: () => {
        toast.error(props.t("Catégorie non ajoutée"), { autoClose: 3000 });
      },
    });
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      designation: null,
    },

    validationSchema: Yup.object().shape({
      designation: Yup.string().required(props.t("Entrer une catégorie")),
    }),

    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Création de catégorie")}
          pageTitle={props.t("Catégorie")}
        />

        <Row>
          <Col lg={12}>
            <Form
              encType="multipart/form-data"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="designation">
                      {props.t("Titre de la catégorie")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      placeholder={props.t("Entrer un nom")}
                      name="designation"
                      value={validation.values.designation}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.designation &&
                    validation.touched.designation ? (
                      <FormFeedback type="invalid">
                        {validation.errors.designation}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
              <div className="text-end mb-3">
                <Link to="/categories" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm m-2"
                  disabled={createCategoryMutation.isPending}
                >
                  {createCategoryMutation.isPending && (
                    <Spinner size="sm" className="me-2" />
                  )}
                  {props.t("Ajouter")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

EcommerceAddCategories.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(EcommerceAddCategories));
